<template>
  <div class="manage-open-invoice-widget d-flex justify-content-between">
    <div class="text-wrap">
      <div class="drip-h3">
        {{ $t('dashboard.manageAndCoversion.manageTitle') }}
      </div>
      <div class="drip-h4 font-weight-400 mt-1">
        {{ $t('dashboard.manageAndCoversion.saveMoreTitle') }}
      </div>
      <div class="d-flex p-3 p-md-0 mt-24">
        <action-button
          variant="solid"
          :click="openDialog"
          class="mr-3"
          v-if="!isDripSwitchEnabled"
        >
          {{ $t('dashboard.conversionRateDetailsWidget.enableINRButtonText') }}
        </action-button>
        <action-button variant="outline" :click="redirectToCurrencySettings">
          {{ $t('dashboard.openInvoiceCard.button') }}
          <b-icon-chevron-right class="wealthy-green-color ml-2" />
        </action-button>
      </div>
    </div>
  </div>
</template>
<script>
import ActionButton from '@/components/common/ActionButton'

export default {
  data() {
    return {
      isEnableDripSwitchModalOpen: false
    }
  },
  props: ['invoiceStageCounters', 'isDripSwitchEnabled'],
  computed: {
    totalInvoiceCount() {
      if (this.invoiceStageCounters?.counters) {
        return Object.values(this.invoiceStageCounters.counters).reduce(
          (x, y) => x + y,
          0
        )
      }
      return 0
    },
    openInvoiceCount() {
      let sum = 0
      if (this.invoiceStageCounters && this.invoiceStageCounters.groups) {
        this.invoiceStageCounters.groups.pending.forEach((ele) => {
          if (
            Object.keys(this.invoiceStageCounters.counters).indexOf(ele) > -1
          ) {
            sum += this.invoiceStageCounters.counters[ele]
          }
        })
      }
      return sum
    }
  },
  methods: {
    redirectToCurrencySettings() {
      this.$mpTrack(
        'Clicks "Currency settings" on the "Manage your open invoices… save more!" tile on the main dashboard'
      )
      this.$router.push({ name: 'currencySettings' })
    },
    openDialog() {
      if (this.$route.name === 'dashboard') {
        this.$mpTrack('Clicks "Enabled INR payments" on the main banner')
      }
      if (this.$route.name === 'currencySettings') {
        this.$mpTrack(
          'Clicks "Enable INR Payment" on the currency settings page'
        )
      }
      this.$emit('openDialog')
    }
  },
  components: { ActionButton }
}
</script>
<style lang="scss" scoped>
.manage-open-invoice-widget {
  position: relative;
  border: 1px solid $sky-blue;
  border-radius: 8px;
  padding: 24px;
  color: $noble-blue-500;
  background-image: url('../../assets/images/common/manage-card-banner.svg'); /* Path to your image */
  background-position: right 33%; /* Start at 62% horizontally and center vertically */
  background-size: 33% 100%; /* Scale to cover 33% of the container width */
  background-repeat: no-repeat;
  .newly-launch-sticker {
    position: absolute;
    top: 16px;
    right: 0;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    padding: 7px 14px;
    background: $sky-blue-400;
    color: $white;
    border-radius: 4px 0px 0px 4px;
    font-weight: 700;
    font-size: 16px;
    line-height: 19px;
  }
  .open-invoice-content {
    .stats-title {
      display: flex;
      align-items: center;
      font-weight: 400;
      font-size: 24px;
      line-height: 28px;
      span:first-child {
        margin-left: 0;
        margin-right: 12px;
      }
      span {
        margin-left: 12px;
        margin-right: 12px;
        font-weight: 400;
        font-size: 36px;
        line-height: 42px;
      }
      @include media-breakpoint-down(md) {
        flex-wrap: wrap;
        span {
          font-size: 24px;
        }
      }
    }
    .stats-title {
      font-weight: 400;
      font-size: 18px;
      line-height: 21px;
    }
  }
  .currency-settings-button {
    height: 40px;
    width: 100%;
    display: flex;
    align-items: center;
    font-weight: 700;
    font-size: 16px;
    line-height: 22px;
    color: $wealthy-green-500;
    cursor: pointer;
    margin-top: 8px;
    width: max-content;
    border-radius: 8px;
    padding: 9px 8px;

    &:hover {
      background: $wealthy-green-50;
      text-decoration: underline;
    }
  }
  .text-wrap {
    width: 62%;
  }
}
.mt-24 {
  margin-top: 24px;
}
</style>
